module.exports = __webpack_public_path__ + "img/alma-logo-it_4ea26a94.d47762a1.svg";